import classNames from 'classnames';

import { Button } from '../../../atoms/Button';
import { createPlanIdForTheDiv } from '../helpers';
import { useGetHighestWidth } from '../hooks/useGetHighestWidth';
import type { ComparisonTablePlan } from '../types';

interface Props {
  plan: ComparisonTablePlan;
}

export const PlanItem = ({ plan }: Props) => {
  const isRecommended = plan.variant === 'recommended';

  const width = useGetHighestWidth('.plan-item-title');

  return (
    <div
      id={createPlanIdForTheDiv(plan.id)}
      className={classNames('plan-item-container', isRecommended && 'recommended')}
    >
      <div className="plan-item-main-content">
        <h4 style={{ width }} className="plan-item-title">
          {plan.name}
        </h4>
        <div className="plan-item-details">
          {plan.prePrice && <p>{plan.prePrice}</p>}
          <p className="plan-item-details-price-container">
            <span className="plan-item-details-price">{plan.price}</span>
            <span className="plan-item-details-price__after">{plan.afterPrice}</span>
            <span className="plan-item-details-price__after-mob">{plan.afterPriceMobile}</span>
          </p>
        </div>
      </div>
      {plan.button && (
        <div className={classNames('plan-item-cta-button-container', isRecommended && 'recommended')}>
          <Button
            fullWidth
            variant={plan.button.variant}
            onClick={plan.button.onClick}
            size={plan.button.size}
            className="plan-item-cta-button"
            disabled={plan.button.disabled}
          >
            {plan.button.buttonLabel}
          </Button>
        </div>
      )}
    </div>
  );
};
